export enum CheckResourceState {
  NOT_AVAILABLE = 'notAvailable',
  AFFECTED = 'affected',
  UNAFFECTED = 'unaffected',
}
